<template>
  <div class="Possessed-attestation-content-main" :class="{ 'Possessed-attestation-content-main-mobile': isMobile}">
    <div class="headers">
      BSI是全球权威的标准研发和国际认证评审服务提供商，致力于信息安全领域标准的研发和制定。ISO/IEC 27001信息安全管理体系认证是国际上针对信息安全领域最权威、最被广泛接受和应用的体系认证。它可以有效保证企业在信息安全领域的可靠性，降低企业泄密风险，更好地保护核心数据。ISO/IEC27701建立在ISO/IEC27001要求的基础之上，是保护个人信息的管理体系，规定了建立、实施、维护和持续改进隐私相关所特定的信息安全管理体系的要求。该两项标准已成为国际上公认权威信息安全与隐私保护领域的体系认证主流标准。
    </div>
    <div class="main">
      <PossessedAttestationContentItem
        v-for="item in dataList"
        :key="item.id"
        :data="item"
      ></PossessedAttestationContentItem>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'PossessedAttestationContent',
    data() {
      return {
        dataList: [
          {
            line1: '最高等级安全认证',
            line2: '手机操作系统',
            Icon: require('@/assets/images/homePage/grade-auth.png'),
            id: 1
          },
          {
            line1: '隐私信息管理体系认证',
            line2: '手机操作系统',
            Icon: require('@/assets/images/homePage/system-auth.png'),
            id: 2
          }
        ]
      };
    }
  };
</script>
<style lang="scss" scoped>
  .Possessed-attestation-content-main {
    margin-top: 0.45rem;
    padding-left: 2.69rem;
    width: 100%;
  }
  .headers {
    font-size: 0.24rem;
    font-family: PingFangTC-Regular, PingFangTC;
    font-weight: 400;
    color: #8B8B8B;
    line-height: 0.48rem;
    letter-spacing: 0.01rem;
    width: 13.96rem;
    text-align: justify;
  }
  .main{
    margin-top: 0.92rem;
    display: flex;
    gap: 0.2rem;
  }
  .Possessed-attestation-content-main-mobile {
    margin-top: 1.38rem;
    padding: 0 .97rem;
    .headers {
      font-size: 0.61rem;
      line-height: 0.98rem;
      letter-spacing: 0.05rem;
      width: 17.15rem;
    }
    .main{
      margin-top: 0.92rem;
      display: flex;
      justify-content: space-between;
    }
  }
</style>
